import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    staffMember: null,
    staff: [],
  },

  getters: {
    staffMember(state) {
      return state.staffMember
    },
    staff(state) {
      return state.staff
    },
  },

  mutations: {
    SET_STAFF_MEMBER(state, value) {
      state.staffMember = value
    },
    SET_STAFF(state, value) {
      state.staff = value
    },
    UPDATE_STAFF(state, data) {
      const index = state.staff.findIndex((item) => String(item.id) === String(data.id))
      if (index >= 0) {
        Object.assign(state.staff[index], data)
      }
    },
    ADD_STAFF(state, data) {
      state.staff.unshift(data)
    },
  },

  actions: {
    async loadStaffMember({ commit }, staffId) {
      const response = await axios.get(`api/staff/${staffId}`)
      commit('SET_STAFF_MEMBER', response.data)
      return response.data
    },
    loadStaff({ commit }) {
      return axios.get('api/staff').then((response) => {
        commit('SET_STAFF', response.data.data)
      })
    },
    updateStaff({ commit }, { formData }) {
      return axios
        .post(`api/staff/${formData.get('id')}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const data = response.data.data ?? response.data
          commit('UPDATE_STAFF', data)
          return data
        })
    },
    addStaff({ commit }, { formData }) {
      return axios
        .post('api/staff', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const data = response.data.data ?? response.data
          commit('ADD_STAFF', data)
          return data
        })
    },
  },
}
